import React from "react";

export default function HowItWorks() {
  const steps = [
    {
      title: "Request a Quote",
      desc: "Share shipment details & receive instant pricing.",
      icon: "bi-chat-left-dots"
    },
    {
      title: "Pickup & Processing",
      desc: "SWIFTSHIP team collects, secures & processes your package.",
      icon: "bi-box-seam"
    },
    {
      title: "Track & Deliver",
      desc: "Track your shipment live until it reaches the destination.",
      icon: "bi-geo-alt"
    }
  ];

  return (
    <>
      {/* ⭐ INLINE PREMIUM CSS */}
      <style>{`
        .how-section {
          background: linear-gradient(135deg, #f3f7ff, #ffffff);
          padding: 80px 0;
          position: relative;
        }

        /* Line connecting steps */
        .step-line {
          position: absolute;
          top: 55%;
          left: 50%;
          width: 70%;
          transform: translateX(-50%);
          height: 4px;
          background: rgba(0,0,0,0.07);
          z-index: 1;
        }

        /* Card container */
        .how-card {
          position: relative;
          z-index: 5;
          background: rgba(255, 255, 255, 0.8);
          backdrop-filter: blur(10px);
          border-radius: 20px;
          padding: 40px 25px;
          transition: 0.4s ease;
          border: 1px solid rgba(0,0,0,0.08);
          box-shadow: 0px 10px 30px rgba(0,0,0,0.1);
        }

        .how-card:hover {
          transform: translateY(-10px);
          box-shadow: 0px 15px 35px rgba(0,0,0,0.15);
          border-color: #005eff;
        }

        /* Step icon */
        .how-icon {
          font-size: 45px;
          color: #005eff;
          margin-bottom: 15px;
          transition: 0.3s;
        }

        .how-card:hover .how-icon {
          color: #f80b0b;
          transform: scale(1.2);
        }

        /* Step Number */
        .step-num {
          width: 55px;
          height: 55px;
          background: #005eff;
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 20px auto;
          font-size: 22px;
          font-weight: 700;
          transition: 0.3s ease;
          box-shadow: 0px 5px 18px rgba(0, 94, 255, 0.4);
        }

        .how-card:hover .step-num {
          background: #f80b0b;
          box-shadow: 0px 5px 18px rgba(248, 11, 11, 0.4);
          transform: scale(1.15);
        }

        .how-title {
          font-weight: 700;
          font-size: 22px;
        }

        .how-desc {
          color: #555;
          font-size: 16px;
          margin-top: 10px;
        }

        /* Fade + delay animation */
        .fadeUp {
          opacity: 0;
          animation: fadeUp 0.9s forwards;
        }

        @keyframes fadeUp {
          0% { opacity: 0; transform: translateY(25px); }
          100% { opacity: 1; transform: translateY(0); }
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
          .step-line {
            display: none;
          }
        }
      `}</style>

      {/* ⭐ SECTION */}
      <section className="how-section">
        <div className="step-line"></div>

        <div className="container">
          <h2
            className="fw-bold text-center mb-3 fadeUp"
            style={{ animationDelay: "0.1s" }}
          >
            How It Works
          </h2>

          <p
            className="text-center text-muted mb-5 fadeUp"
            style={{ animationDelay: "0.2s" }}
          >
            Simple, Fast & Professional Logistics Workflow Designed for You
          </p>

          <div className="row">

            {steps.map((step, index) => (
              <div
                className="col-md-4 text-center mb-4 fadeUp"
                key={index}
                style={{ animationDelay: `${0.3 + index * 0.2}s` }}
              >
                <div className="how-card">

                  {/* Animated Step Number */}
                  <div className="step-num">{index + 1}</div>

                  {/* Icon */}
                  <i className={`bi ${step.icon} how-icon`}></i>

                  {/* Title */}
                  <h4 className="how-title">{step.title}</h4>

                  {/* Description */}
                  <p className="how-desc">{step.desc}</p>

                </div>
              </div>
            ))}

          </div>

        </div>
      </section>
    </>
  );
}
